import QrReader from "../QrReader.vue";
import LossReasonSelect from "../LossReasonSelect.vue";
import OrderList from "../OrderList.vue";
import CakeQuestion from "../CakeQuestion.vue";
import { addDiscountLog } from "@/api/SelfService";
import companyInfo from "@/model/constants/companyInfo";
export default {
  props: {
    isKiosk: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      baskets: [],
      basketCount: 0,
      selected: "",
      moment: require('moment-timezone'),
      currentTime: "",
      broadcaster: null,
      isTransaction: false
    };
  },
  components: {
    OrderList,
    CakeQuestion,
    LossReasonSelect,
    QrReader
  },
  mounted() {
    this.getCurrentTime();
  },
  watch: {
    selected: {
      deep: true,
      handler(val) {
        if (val.id && !this.lossMode) {
          //this.$store.dispatch("selfservice/setToUpdateEntry", null)
          this.$store.dispatch("selfservice/setSelectedProduct", null);
          this.$store.dispatch("selfservice/setPreSelectedProduct", null);
          this.$nextTick(() => {
            this.$store.dispatch("selfservice/setToUpdateEntry", val);
          });
        }
      }
    },
    toUpdateEntry(val) {
      if (!val) this.selected = "";
    },
    // Sepetteki değişiklikleri izle
    'currentCart.cartEntries': {
      deep: true,
      handler(newCartEntries) {
        console.log('handle', newCartEntries);
        if (newCartEntries) {
          // Değişiklikleri yayınla
          this.broadcaster.postMessage({
            type: 'CART_UPDATE',
            data: newCartEntries
          });
        }
      }
    }
  },
  beforeDestroy() {
    // Kanalı temizle
    if (this.broadcaster) {
      this.broadcaster.postMessage({
        type: 'CART_UPDATE',
        data: []
      });
      this.broadcaster.close();
    }
  },
  created() {
    this.broadcaster = new BroadcastChannel('cart-channel');
    console.log(this.currentCart.cartEntries);
    if (this.currentCart.cartEntries) {
      this.broadcaster.postMessage({
        type: 'CART_UPDATE',
        data: []
      });
    }

    //   this.broadcaster.onmessage = (event) => {
    //   if (event.data.type === 'CART_UPDATE') {
    //     console.log(event.data.data);
    //   }
    // };
  },
  computed: {
    isCakeQuestioned: {
      get() {
        return this.$store.getters["selfservice/getCakeQuestioned"];
      },
      set(val) {
        this.$store.dispatch("selfservice/setCakeQuestioned", val);
      }
    },
    isOrderListActive() {
      return this.$refs.orderList ? this.$refs.orderList.isActive : false;
    },
    selectedLossStocks() {
      return this.$store.getters["selfservice/getSelectedLossStocks"]
    },
    lossTypeSelection: {
      get() {
        return this.$store.getters["selfservice/getLossType"];
      },
      set(val) {
        this.$store.dispatch("selfservice/setLossType", val);
      }
    },
    lossMode: {
      get() {
        return this.$store.getters["selfservice/getLossMode"];
      },
      set(val) {
        this.$store.dispatch("selfservice/setLossMode", val);
      }
    },
    currentCart: function () {
      return this.$store.getters["selfservice/getCurrentCart"];
    },
    carts: function () {
      return this.$store.getters["selfservice/getCarts"];
    },
    isScreenLock: {
      get() {
        return this.$store.getters["selfservice/getScreenLock"];
      },
      set(val) {
        this.$store.dispatch("selfservice/setScreenLock", val);
      }
    },
    activePersonal: {
      get() {
        return this.$store.getters["selfservice/getActivePersonal"];
      },
      set(val) {
        this.$store.dispatch("selfservice/setActivePersonal");
      }
    },
    toUpdateEntry() {
      return this.$store.getters["selfservice/getToUpdateEntry"];
    },
    currentDate() {
      let date = this.moment().locale("tr");
      date = date.tz("Europe/Istanbul").format("ddd Do MMM")
      return date;
    },
    getCartLabel() {
      return (cartId) => {
        if (cartId > 1500000000000) {
          if (this.carts.length > 1) {
            let idx = this.carts.findIndex(c => c.id === cartId);
            return idx + 1;
          }
          return "1";
        }
        return cartId;
      }
    }
  },
  methods: {
    goToSelfService() {
      this.$store.dispatch("selfservice/clearAllCarts");
      window.location.href = '/pages/SelfService';
    },
    clearQr() {
      this.$store.dispatch("selfservice/setCurrentCartCustomer", null);
    },
    commitQrCode(customer) {
      this.$store.dispatch("selfservice/setCurrentCartCustomer", customer);
    },
    openQrReader() {
      this.$refs.qrReader.isActive = true;
    },
    submitLoss: function () {
      let obj = {
        stockEntries: this.selectedLossStocks,
        branchId: 0,
        userId: 0,
        type: "Stock"
      };
      if (this.isTransaction) return;
      this.isTransaction = true;
      this.$refs.lossReasonSelect.isActive = true;
      this.$refs.lossReasonSelect.lossData = obj;
    },
    clearLossList() {
      if (this.selected.id) this.$store.dispatch("selfservice/removeSelectedLossStock", this.selected.id);
      else this.$store.dispatch("selfservice/clearSelectedLossStocks");
      this.selected = "";
    },
    setBillExtras(extras) {
      let returnObj = [];
      extras.forEach(x => {
        if (x.quantity > 0) {
          returnObj.push(x);
        } else if (x.quantity == 0 && x.variants != null && x.variants.length > 0) {
          x.variants.filter(y => y.quantity > 0).forEach(z => {
            returnObj.push(z);
          })
        }
      });
      return returnObj;
    },
    returnSelectedExtraVariant(extra) {
      let returnObj = [];
      let selectedVariants = extra.variants.filter(x => {
        if (x.quantity > 0) {
          returnObj.push("x" + x.quantity + " | " + x.name)
        }
      });
      return returnObj.length > 0 ? returnObj : null;
    },
    moveOnToOrderList() {
      this.isTransaction = false;
      this.$refs.cakeQuestion.isActive = false;
      this.$refs.orderList.isActive = true;
    },
    getCurrentTime() {
      this.currentTime = this.moment().locale("tr");
      this.currentTime = this.currentTime.tz('Europe/Istanbul').format("H:mm:ss");
      setTimeout(this.getCurrentTime, 1000)
    },
    RemoveSpecificEntry(entry) {
      if (entry) {
        this.$store.dispatch("selfservice/removeEntryFromCurrentCart", entry);
        this.$store.dispatch("selfservice/setToUpdateEntry", null);

        // Logging for Delete
        try {
          addDiscountLog({
            tableId: 0,
            ids: [entry.id],
            totalDiscount: 0,
            discountType: "Cancel",
            actionType: "Cancel",
            description: "Kiosk Individual Delete",
            items: [entry]
          });
        } catch (logErr) {
          console.error("StaffActionLog Individual Delete error:", logErr);
        }

        if (this.currentCart.cartEntries.length == 0) {
          this.$store.dispatch("selfservice/removeCart", this.currentCart.id);
          this.isCakeQuestioned = false;
          if (this.isKiosk) {
            this.$store.dispatch("selfservice/setIsReset", true);
          }
        }
      }
    },
    ClearCart: function () {
      if (this.currentCart.cartEntries.length > 0) {
        const selectedItem = this.selected;
        this.$store.dispatch("selfservice/removeEntryFromCurrentCart", this.selected);
        this.$store.dispatch("selfservice/setToUpdateEntry", null)

        // Logging for Delete
        if (selectedItem) {
          try {
            addDiscountLog({
              tableId: 0,
              ids: [selectedItem.id],
              totalDiscount: 0,
              discountType: "Cancel",
              actionType: "Cancel",
              description: "",
              items: [selectedItem]
            });
          } catch (logErr) {
            console.error("StaffActionLog Delete error:", logErr);
          }
        }
      }
      if (this.currentCart.cartEntries.length == 0) {
        this.$store.dispatch("selfservice/removeCart", this.currentCart.id);
        this.isCakeQuestioned = false;
        if (this.isKiosk) {
          this.$store.dispatch("selfservice/setIsReset", true);
        }
      }
    },
    PlaceOrder: function () {
      if (this.isTransaction) return;
      this.isTransaction = true;
      console.log(this.currentCart.cartEntries);
      let orderBillEntries = [];
      this.currentCart.cartEntries.forEach(tr => {
        orderBillEntries.push({
          productId: tr.productId,
          childProductId: tr.childProductId,
          productQuantity: tr.quantity,
          productName: tr.productName,
          recipe: tr.recipe,
          variantItems: tr.recipe.steps.filter(x => x.selected == true && x.isDefault == false),
          extras: this.setBillExtras(tr.extras),
          price: (tr.price / tr.quantity) - this.sumOfExtraPrices(tr.extras)
        });
      });
      if (!this.lossMode) {
        this.$refs.orderList.orderBillEntries = orderBillEntries;
        // this.$store.dispatch("selfservice/removeEntryFromCurrentCart", null);
        let navigationQuestion = this.$store.getters["selfservice/getNavigationQuestion"];
        if ((navigationQuestion.categoryId != null || navigationQuestion.productId != null) && !this.isCakeQuestioned && !this.currentCart.cartEntries.some(entry => entry.categories.some(category => category.id == navigationQuestion.categoryId))) {
          this.$refs.cakeQuestion.isActive = true;
        } else {
          this.moveOnToOrderList();
        }
      } else {
        let obj = {
          entries: orderBillEntries,
          branchId: 0,
          userId: 0,
          type: "Product"
        };
        this.$refs.lossReasonSelect.isActive = true;
        this.$refs.lossReasonSelect.lossData = obj;
      }
    },
    sumOfExtraPrices(extras) {
      let sum = 0;
      extras.forEach(x => {
        if (x.variants != null && x.variants.length > 0) {
          x.variants.forEach(y => {
            sum += y.price * y.quantity;
          });
        } else {
          sum += x.price * x.quantity;
        }
      });
      return sum;
    },
    openNewBasket() {
      let id = Date.now();
      let newCart = {
        id: id,
        cartEntries: [],
        totalPrice: 0,
        active: true
      };
      this.$store.dispatch("selfservice/createNewCart", newCart);
      this.$store.dispatch("selfservice/setToUpdateEntry", null)
      this.$store.dispatch("selfservice/setCakeQuestioned", false)
      if (this.isKiosk) {
        this.$store.dispatch("selfservice/setIsReset", true);
      }
    },
    chanceCurrentCart(cart) {
      this.$store.dispatch("selfservice/setCurrentCart", cart);
      this.$store.dispatch("selfservice/setToUpdateEntry", null)
    },
    getBranchName() {
      const name = this.activePersonal && this.activePersonal.branch ? this.activePersonal.branch.name : '';
      return name ? name.toLocaleUpperCase('tr-TR') : '';
    },
    getBranchLogo() {
      // 1. Aday Nesneleri Belirle
      const candidates = [];
      
      const savedBranch = localStorage.getItem("branch");
      if (savedBranch) {
        try { candidates.push(JSON.parse(savedBranch)); } catch (e) { }
      }
      
      if (this.activePersonal) {
        if (this.activePersonal.branch) candidates.push(this.activePersonal.branch);
        if (this.activePersonal.userBranch) candidates.push(this.activePersonal.userBranch);
        candidates.push(this.activePersonal); // Personel avatarını en sona al (Şube logosu öncelikli)
      }

      const user = this.$store.getters["getActiveUser"];
      if (user) {
        if (user.branch) candidates.push(user.branch);
        candidates.push(user);
      }

      // 2. Agresif Tarama Fonksiyonu (Nesne içindeki her şeyi tara)
      const findImagePath = (obj, depth = 0) => {
        if (!obj || depth > 3) return null;
        
        // Önce bilinen alanlara bak (Öncelikli)
        const priorityFields = ['Photo', 'photo', 'imageUrl', 'ImageUrl', 'logo', 'Logo', 'branchLogo', 'PhotoUrl'];
        for (const field of priorityFields) {
          if (obj[field] && typeof obj[field] === 'string' && obj[field].length > 5) return obj[field];
        }

        // Sonra tüm string alanları tara
        for (const key in obj) {
          const val = obj[key];
          if (typeof val === 'string' && val.length > 5) {
            const lowVal = val.toLowerCase();
            // Eğer değer bir resim yolu gibi görünüyorsa veya StaticFiles içeriyorsa
            if (lowVal.includes('/staticfiles/') || 
                lowVal.includes('static/images') || 
                lowVal.endsWith('.jpg') || 
                lowVal.endsWith('.png') || 
                lowVal.endsWith('.jpeg')) {
              return val;
            }
          }
          // İç içe nesne varsa (limitli derinlikte)
          if (val && typeof val === 'object' && !Array.isArray(val)) {
            const sub = findImagePath(val, depth + 1);
            if (sub) return sub;
          }
        }
        return null;
      };

      let photo = null;
      for (const cand of candidates) {
        photo = findImagePath(cand);
        if (photo) break;
      }

      if (photo) {
        if (typeof photo === 'string' && photo.startsWith('http')) return photo;
        const cleanPhoto = typeof photo === 'string' ? (photo.startsWith('/') ? photo.slice(1) : photo) : photo;
        const cleanBaseUrl = this.$baseUrl.endsWith('/') ? this.$baseUrl.slice(0, -1) : this.$baseUrl;
        return cleanBaseUrl + '/' + cleanPhoto;
      }
      
      return companyInfo.logo;
    }
  }
};
